import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { w3cwebsocket } from 'websocket';

import { WEBSOCKET_URL } from 'settings';
import { getCurrentSessionData } from 'utils/aws/cognito';

function WssProvider() {
  const { enqueueSnackbar } = useSnackbar();
  const { accessToken } = getCurrentSessionData();
  const { t } = useTranslation();
  const wssClient = new w3cwebsocket(`${WEBSOCKET_URL}/user?token=${accessToken}`);

  useEffect(() => {
    wssClient.onopen = () => {
      console.debug('WebSocket client: Connected');
    };

    wssClient.onmessage = ({ data }) => {
      const message = JSON.parse(data);

      switch (message.type) {
        default: { break; }
      }

      enqueueSnackbar(t(message.name), {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        autoHideDuration: 5000,
        variant: message.level || 'default',
      });
    };

    wssClient.onclose = () => {
      console.debug('WebSocket client: Disconnected');
    };

    return () => wssClient.close();
  }, []);

  return (<></>);
}

export default WssProvider;
